import { FC } from "react";
import { components } from "react-select";
import styled from "styled-components";
import { getTextVariant } from "./getTextVariant";
import { inputTypography } from "./inputTypography";
import { InputVariant, SelectComponentProps } from "./types";
import { useDropdownContext } from "./DropdownContext";
import { styleWrappedComponent } from "./styleWrappedComponent";
import { IconVariantArgs, LabelWithIcon } from "./LabelWithIcon";

type StyledSingleValueProps = { variant: InputVariant };
const StyledSingleValue = styled.div<StyledSingleValueProps>`
  ${(props) => styleWrappedComponent(inputTypography(props.variant))};
`;

type SingleValueProps = SelectComponentProps["SingleValue"];

export const SingleValue: FC<SingleValueProps> = ({ children, ...props }) => {
  const {
    selectProps: { translateOptions = true, ...selectProps },
    data: { iconName },
  } = props;
  const { variant, hasSelectedOption, allowIcons } = useDropdownContext();
  const isReadOnly = variant === "READONLY";
  const iconVariantArgs: IconVariantArgs = {
    ...(variant === "READONLY" && { isReadOnly: true }),
    ...selectProps,
  };

  return (
    <StyledSingleValue
      variant={getTextVariant({
        ...props.selectProps,
        isReadOnly,
        hasSelectedOption,
      })}
      {...(translateOptions ? {} : { "data-notranslate": "true" })}
    >
      <components.SingleValue {...props} className="single-value-dropdown">
        <LabelWithIcon
          iconName={iconName}
          allowIcons={allowIcons}
          IconVariantArgs={iconVariantArgs}
        >
          {children}
        </LabelWithIcon>
      </components.SingleValue>
    </StyledSingleValue>
  );
};
